import { createServerFn } from "@tanstack/react-start";
import { readGift, readGiftShop, readMyGifts } from "./gifts.server";
import { siteContext } from "./site.server";

const text = (value: unknown, max: number) =>
  typeof value === "string" && value.length <= max ? value : "";

/** Gift memberships: /join/gift, /join/gift/<code> and /account/gifts (./gifts.server.ts). */
export const loadGiftShop = createServerFn({ method: "GET" }).handler(async ({ context }) =>
  readGiftShop(await siteContext(context)),
);

export const loadGift = createServerFn({ method: "GET" })
  .validator((code: unknown) => text(code, 64))
  .handler(async ({ data, context }) => readGift(await siteContext(context), data));

export const loadMyGifts = createServerFn({ method: "GET" })
  .validator((input: unknown) => {
    const { gift, checkout } = (input ?? {}) as Record<string, unknown>;
    return { gift: text(gift, 36), checkout: text(checkout, 300) };
  })
  .handler(async ({ data, context }) => readMyGifts(await siteContext(context), data));
